import type { BrandConfig } from "./types";

const brandConfig: BrandConfig = {
  name: "Water Bureau",
  logo: "/logo.webp",
  icon: "/icon.webp",
  favicon: "/favicon.ico",
  apiUrl: "https://api-dev.waterbureau.com.au",
  features: {
    deviceTypeFilter: true,
    deviceControls: true,
    addDeviceButtonPlacement: "header",
    brandingIcon: true,
    deviceTypeIcon: true,
    deviceSubTypeIcon: true,
    deviceItemAccentLine: true,
    tenantBadge: true,
    settingsNotifications: false,
  },
  header: {
    variant: "waterbureau",
    accentText: "Water",
    normalText: "Bureau",
  },
  strings: {
    logoAlt: "Water Bureau Logo",
    copyright: "© 2025 Water Bureau. All rights reserved.",
    supportEmail: "support@waterbureau.com",
    councilName: "Water Bureau",
  },
};

export default brandConfig;

let currentBrandConfig: BrandConfig = { ...brandConfig };

export function getCurrentBrandConfig(): BrandConfig {
  return currentBrandConfig;
}

export function updateCurrentBrandConfig(partial: Partial<BrandConfig>) {
  currentBrandConfig = { ...currentBrandConfig, ...partial };
}
